import { render, staticRenderFns } from "./WeeklyActivityTrackerIcon.vue?vue&type=template&id=65b9d274&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports